<template>
    <span class="status-badge" :class="statusStylePair[status]">
        <slot></slot>
    </span>
</template>
<script>
    export default {
        name: "statusBadge",
        props: {
            status : {type : String}
        },
        data() {
            return {
                statusStylePair: {
                    TO_DO : 'badge-to-do',
                    IN_PROGRESS : 'badge-in-progress',
                    DONE : 'badge-done',
                    CANCELLED : 'badge-cancelled',
                    CLOSED : 'badge-closed',
                    OPEN: 'badge-open',
                    OVERDUE: 'badge-overdue'
                }
            }
        }
    }
</script>
<style scoped>
.status-badge {
    padding: 0.1rem 0.5rem;
    border-radius: 20px;
    font-weight: bold;
    width: 80%;
}
.badge-to-do {
    background-color : #e7e7ebda;
    color: #2E2E38;
}
.badge-in-progress {
    background-color : #F5ECD6;
    color: #FF5C00;   
}
.badge-done {
    background-color : #CFDDFF;
    color: #1755CC;   
}
.badge-cancelled {
    background-color : #E4E4EA;
    color: rgba(116, 116, 128, 0.70);
}
.badge-closed {
    background-color : #D7F5D6;
    color: #168D4C;   
}
.badge-open {
    background-color : #d9d9db;
    color: #2E2E38;
}
.badge-overdue {
    background-color: #f5d6d6;
    color: #d75b5b;
}
</style>